"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("../TextField"));
var Button_1 = __importDefault(require("../Button"));
var SingleSubmitField = function (_a) {
    var disabled = _a.disabled, buttonDisabled = _a.buttonDisabled, buttonText = _a.buttonText, onSubmit = _a.onSubmit, value = _a.value, onChange = _a.onChange, error = _a.error, helperText = _a.helperText, id = _a.id, name = _a.name, onBlur = _a.onBlur, multiline = _a.multiline, autoFocus = _a.autoFocus, fullWidth = _a.fullWidth, autoComplete = _a.autoComplete, placeHolder = _a.placeHolder, tabIndex = _a.tabIndex, ariaLabel = _a.ariaLabel, label = _a.label, defaultValue = _a.defaultValue, _b = _a.maxLength, maxLength = _b === void 0 ? 500 : _b, _c = _a.displayCount, displayCount = _c === void 0 ? false : _c;
    return (react_1.default.createElement("form", { onSubmit: function (e) {
            e.preventDefault();
            if (onSubmit) {
                return onSubmit();
            }
        } },
        react_1.default.createElement(TextField_1.default, { displayCount: displayCount, maxLength: maxLength, value: value, onChange: onChange, error: error, helperText: helperText, id: id, name: name, onBlur: onBlur, multiline: multiline, autoFocus: autoFocus, fullWidth: fullWidth, autoComplete: autoComplete, placeholder: placeHolder, tabIndex: tabIndex, inputRef: function (input) { return input && autoFocus && input.focus(); }, onFocus: function (e) {
                return e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length);
            }, disabled: disabled, label: label, defaultValue: defaultValue, sx: {
                '.MuiInputBase-root': {
                    paddingRight: '8px',
                    paddingTop: multiline ? '8px' : '',
                },
                '.MuiInputBase-input': {
                    paddingTop: multiline && label ? '16px' : multiline || !label ? '8px' : '',
                },
            }, InputProps: {
                endAdornment: (react_1.default.createElement(Button_1.default, { variant: "text", disabled: disabled || buttonDisabled, type: "submit", "data-testid": "submit-field-button", style: { height: '40px', alignSelf: 'center' } }, buttonText)),
            }, inputProps: {
                'aria-label': ariaLabel,
            } })));
};
exports.default = SingleSubmitField;
//# sourceMappingURL=SingleSubmitField.js.map